// Generic helper to render form fields based on schema
import { Checkbox, Input, Select } from '@/components/Form'

/**
 * Renders a form field from a schema definition.
 * @param {object} field - Field schema (name, label, type, required, options, ...)
 * @param {object} [customOptions] - Optional map of fieldName to options array for selects
 * @returns React element
 */
export function renderFormField(field) {
  if (field.type === 'checkbox') {
    return <Checkbox key={field.name} name={field.name} label={field.label} isRow isRequired={field.required} />
  }
  if (field.type === 'select') {
    // Use options from field.options, or from customOptions[field.name], or []
    let options = field.options || []
    return (
      <Select
        key={field.name}
        name={field.name}
        label={field.label}
        options={options}
        isRow
        isRequired={field.required}
      />
    )
  }
  // Default to Input
  return (
    <Input key={field.name} name={field.name} label={field.label} type={field.type} isRow isRequired={field.required} />
  )
}
